export default function useLazyloadComponent (componentPath: string) {
    return import(/* webpackChunkName: "[request]" */ "@/" + componentPath)
}

export {
    useLazyloadComponent
}
